// extracted by mini-css-extract-plugin
module.exports = {"ServiceInstanceFormat":"ServiceInstanceFormat_J4UR4","ServiceInstanceFormat_instance":"ServiceInstanceFormat_instance_uzhFm"};